import React, { useState, useEffect } from "react";
import "./NotLoggedInMessage.css";
import {
  FaCode,
  FaCogs,
  FaProjectDiagram,
  FaChartBar,
  FaSignInAlt,
  FaStore,
  FaGlobe,
} from "react-icons/fa";
import { isMobile } from "react-device-detect";
//import { Link } from "@mui/material";
import { Link } from 'react-router-dom';
import { useMyContext } from "../MyContext";
import ReactPlayer from 'react-player'
import { useParams } from "react-router-dom";
// import QuickStart from "../pages/QuickStartNew";
import SuperAppButton from "./SuperAppButton";

import RichContentCarousel from "./RichContentCarousel";
import { sendChatMessage } from "../utils/utils"

export default function NotLoggedInMessage(props) {
  // const superAppStyle = useContext(GlobalContext)["superAppStyle"];
  const [randomValue, setRandomValue] = useState(0);
  const [videos, setVideos] = useState(["./koodums_demo.mov", "./koodums_restaurant_demo.mov", "./koodums_association_demo.mov"])
  const [video, setVideo] = useState("./marketing_video_v1.mov")
  const [titles, setTitles] = useState(["Generic Travel Chatbot Demo", "Generic Restaurant Chatbot Demo", "Generic Association Chatbot Demo"]);
  const myContext = useMyContext();

  function shuffleArray(array1, array2) {
    for (let i = array1.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array1[i], array1[j]] = [array1[j], array1[i]];
      [array2[i], array2[j]] = [array2[j], array2[i]];
    }
    return { array1: array1, array2: array2 };
  }
  function getRandomNumber(x) {
    if (typeof x !== 'number' || !Number.isInteger(x) || x < 0) { // Changed x <= 0 to x < 0
      throw new Error("Input must be a non-negative integer."); // Changed to non-negative
    }
    return Math.floor(Math.random() * (x + 1)); // Changed x to (x+1)
  }
  const { source } = useParams();

  useEffect(() => {
    //console.log("IN HERE NotLoggedIn UseEffect");
    async function loadComponent() {
      setRandomValue(getRandomNumber(3));
      if (videos) {
        const result = shuffleArray(videos, titles);
        setVideos(result.array1);
        setTitles(result.array2);
      }
      var ipAddress = myContext["data"]["ipAddress"];
      var city = myContext["data"]["city"];
      var country = myContext["data"]["country"];

      if (typeof ipAddress === 'undefined') ipAddress = "localhost";

      if (ipAddress !== 'localhost') {
        sendChatMessage("Home page hit " + (document.referrer && document.referrer.len ? "(referrer = " + document.referrer + "), " : "") + ipAddress + (ipAddress !== "localhost" ? " in " + city + "," + country : "") + " (" + myContext["data"]["environmentName"] + ")" + (source !== null && typeof source !== "undefined" ? "(source = " + source + ")" : ""));
      }
    }
    loadComponent();
  }, [videos]);

  const handleGetStartedLink = () => {
    console.log("in handleGetStartedLink");
    var ipAddress = myContext["data"]["ipAddress"];
    var city = myContext["data"]["city"];
    var country = myContext["data"]["country"];

    if (typeof ipAddress === 'undefined') ipAddress = "localhost";

    sendChatMessage("Get Started Clicked By " + ipAddress + (ipAddress !== "localhost" ? " in " + city + "," + country : "") + " (" + myContext["data"]["environmentName"] + ")");
    window.dataLayer.push({
      'event': 'get_started_link_pressed_event',
      'event_category': 'example',
      'event_action': 'button_click',
      'event_label': 'submit_button',
      'event_value': 1
    })
  }

  const features = [
    {
      title: "Build AI Agents Without Coding Expertise",
      description:
        "No coding required, just an easy-to-use editor that simplifies agent/chatbot creation.",
      icon: <FaCode />,
    },
    {
      title: "Customizable AI to Fit Your Business Needs",
      description:
        "Your business is unique, and so are your needs. The GenAI Agent Builder allows full customization of the agent/chatbot.",
      icon: <FaCogs />,
    },
    {
      title: "Seamless Integration with Existing Systems",
      description:
        "Our integration capabilities allow AI agents to work within your existing tech ecosystem.",
      icon: <FaProjectDiagram />,
    },
    {
      title: "Data-Driven Insights to Optimize Performance",
      description:
        "Gain actionable insights with comprehensive analytics and reporting tools.",
      icon: <FaChartBar />,
    },
  ];

  return (
    <React.Fragment>
      {!props.user && props.showLoginErrorMessage && (
        <>
          <div className="homepage-container re">
            <div className="hpage-container">
              {/* Header Section */}
              <div className="header">
                <header>
                  <h1 className="header-title">Use Chatbots to Improve Customer Support</h1>
                  <p className="header-description">
                    Create intelligent, responsive chatbots/agents that redefine
                    engagement. With GenAI Agent Builder, you hold the keys to a
                    custom AI experience - tailored, scalable. Useful in all industries (e.g., Retail, Hospitality, Manufacturing, Technology, Finance) and for all departments (e.g., Website, Sales, Marketing, Call Center, Customer Support, Finance, HR, IT, Operations, Training, and others)
                  </p>
                </header>
              </div>
              <div className="buttn">
                <div className="button">
                  <Link
                    to="/signin"
                    type="button"
                    className="primary-gradient-btn"
                    onClick={handleGetStartedLink}
                  >
                    Get Started For Free
                  </Link>
                </div>
              </div>
            </div>

            {/* <section className="hero-section">
              <div className="hero-content">
                <h1>Empower Your Vision</h1>
                <p className="paragraph_descr">
                  Create intelligent, responsive agents that redefine
                  engagement. With GenAI Agent Builder, you hold the keys to a
                  custom AI experience - tailored, scalable, and ready to drive
                  value across your industry.
                </p>
                <button className="get-started-btn">Get Started</button>
              </div>
            </section> */}

            {/* Unlock Section */}
            {/* <section className="unlock-section">
              <div style={{ display: "flex", flexDirection: "row", width: "90%", height: "auto" }}>
                <div className="first_col">
                  <h2 className="title">
                    Build <span>Powerful Agents</span> in Minutes
                  </h2>
                  <p className="paragraph_descr">
                    With Koodums ChatBot Builder, you can design smart, conversational agents without writing a single line of code. Fast, intuitive, and built for creators.
                  </p>
                </div>
                <ReactPlayer url={video} width="100%" height="300px" style={{ borderRadius: "20px", overflow: "hidden"}} loop playing muted />
              </div>
            </section>

            <section className="unlock-section">
              <div style={{ display: "flex", flexDirection: "row", }}>
                <RichContentCarousel
                  content={{ videos: videos, titles: titles }}
                  index={getRandomNumber(2)}
                  name={"name"}
                />
                <div className="first_col">
                  <h2 className="title">
                    See Our <span>Chatbots</span> in Action
                  </h2>
                  <p className="paragraph_descr">
                    From customer support to travel planning and food ordering — our bots are built to engage, assist, and impress.
                  </p>
                </div>
              </div>
            </section> */}

            <section className="unlock-section">
              <div style={{
                display: "flex",
                flexDirection: isMobile || window.innerWidth < 570 ? "column" : "row",
                alignItems: "center",
                justifyContent: "space-between",
                width: "90%",
                margin: "0 auto",
                gap: "40px"
              }}>
                <ReactPlayer
                  url={video}
                  width="300px"
                  height="300px"
                  style={{ borderRadius: "20px", overflow: "hidden" }}
                  loop
                  playing
                  muted
                />
                <div className="first_col" style={{ flex: 1 }}>
                  <h2 className="title" style={{ marginBottom: "20px" }}>
                    Build <span>Powerful Agents</span> in Minutes
                  </h2>
                  <p className="paragraph_descr">
                    Whether you're building a support assistant, virtual concierge, or sales agent, Koodums makes it simple.
                    Our no-code builder lets you create advanced, personalized chatbots with natural flows and smart logic — all in just a few clicks.
                  </p>
                </div>
              </div>
            </section>


            <section className="unlock-section" style={{
              display: "flex",
              flexDirection: isMobile || window.innerWidth < 570 ? "column" : "row",
              alignItems: "center",
              justifyContent: "space-between",
              width: "90%",
              margin: "0 auto",
              gap: "40px"
            }}>
              <div className="first_col" style={{}}>
                <h2 className="title" style={{ marginBottom: "20px" }}>
                  Leverage the <span>Power of AI</span> to Grow and Scale Your Business
                </h2>
                <p className="paragraph_descr">
                  AI can transform your business by providing 24x7 realtime sales and customer support.  One AI Agent can service thousands of customers, and can provide a better customer experience by getting customers the information they need quickly.
                </p>
              </div>
              <div className="second_col">
                <div className="benefits-grid">
                  {[
                    {
                      img: "/images/handshake.png",
                      text: "Increase Productivity",
                    },
                    { img: "/images/victory.png", text: "Increase Sales" },
                    { img: "/images/checked.png", text: "Improve Customer Experience" },
                    { img: "/images/idea.png", text: "Differentiate Your Business" },
                  ].map((item, index) => (
                    <div key={index} className="benefit-item">
                      <img src={item.img} alt={item.text} />
                      <span>{item.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            <section className="unlock-section">
              <div style={{
                display: "flex",
                flexDirection: isMobile || window.innerWidth < 570 ? "column" : "row",
                alignItems: "center",
                justifyContent: "space-between",
                width: "90%",
                margin: "0 auto",
                gap: "40px"
              }}>
                <RichContentCarousel
                  content={{ videos: videos, titles: titles }}
                  index={getRandomNumber(2)}
                  name={"name"}
                />
                <div className="first_col" style={{ flex: 1 }}>
                  <h2 className="title" style={{ marginBottom: "20px" }}>
                    See Our <span>Chatbots</span> in Action
                  </h2>
                  <p className="paragraph_descr">
                    Watch real-world demos of Koodums bots answering customer questions, taking reservations, and handling travel plans.
                    Our chatbots are fast, accurate, and tailored to deliver human-like conversations that actually convert.
                  </p>
                </div>
              </div>
            </section>

            {/* Features Section */}
            <section className="features-section" style={{ flexDirection: isMobile || window.innerWidth < 570 ? "column" : "row", }}>
              <small className="cor">
                AI—no coding required, just innovation
              </small>
              <h2 className="title">
                Effortless <span>AI Agents</span> for Your Business
              </h2>
              <div className="features-grid">
                {features.map((feature, index) => (
                  <div
                    key={index}
                    className="feature-box"
                    data-aos="fade-up"
                    data-aos-delay={index * 200}
                  >
                    <div className="icon">{feature.icon}</div>
                    <h3>{feature.title}</h3>
                    <p>{feature.description}</p>
                  </div>
                ))}
              </div>
            </section>

            <div className="chatbot-container" id="chatbot-container">
              <small className="cor">Welcome To Our Chatbot</small>
              <h2 className="title">
                AI <span>Agent/Chatbot</span> Builder
              </h2>

              <div className="chatbot-content">
                <div className="chatbot-image-first">
                  {[
                    {
                      img: "/images/chatbot-image.png",
                      text: "Chatbot interaction 1",
                    },
                  ].map((item, index) => (
                    <div key={index} className="benefit-item">
                      <img src={item.img} alt={item.text} />
                    </div>
                  ))}
                </div>
                <div className="chatbot-text">
                  <div className="chatbot-section">
                    <div className="dlso">
                      <span className="icon-box"></span>
                      <h2>Build Your First Agent in Minutes</h2>
                    </div>

                    <p>
                      Using this tool, you can create different types of
                      Chatbots/Agents for your business website, or your
                      organization's internal Intranets. Chatbots can be a great
                      way to engage with your customers anonymously and help
                      them get their questions answered.
                    </p>
                  </div>

                  <div className="chatbot-info">
                    {[
                      {
                        icon: <FaSignInAlt />,
                        text: "If you have an account already, please click on the Login link to access the tool.",
                      },
                      {
                        icon: <FaStore />,
                        text: "If you are a customer of WIX, we will be releasing our solution in the WIX marketplace shortly.",
                      },
                      {
                        icon: <FaGlobe />,
                        text: "If you want to create Agents for other websites, please login to get a trial account.",
                      },
                    ].map((item, index) => (
                      <div className="ic" key={index}>
                        <span className="icon">{item.icon}</span>
                        <p>{item.text}</p>
                      </div>
                    ))}
                  </div>
                  {/*
                  <div className="chatbot-buttons">
                    <button className="btn login">Login</button>
                    <button className="btn wix">Wix</button>
                    <button className="btn website">Website Builders</button>
                  </div>
*/}
                </div>
                <div className="chatbot-image">
                  {[
                    {
                      img: "/images/chatbot-image.png",
                      text: "Chatbot interaction 1",
                    },
                  ].map((item, index) => (
                    <div key={index} className="benefit-item">
                      <img src={item.img} alt={item.text} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

        </>
        // <>
        //   {/* start: main-banner */}
        //   <div className="main-banner">
        //     <div className="custom-container">
        //       <div className="text-contianer">
        //         <h1>Empower Your Vision with GenAI Agent Builder.</h1>
        //         <p>
        //           Create intelligent, responsive agents that redefine
        //           engagement. With GenAI Agent Builder, you hold the keys to a
        //           custom AI experience - tailored, scalable, and ready to drive
        //           value across your industry.
        //         </p>
        //         <div className="more-action">
        //           <Link
        //             href={"#genAiSolution-Welcome-sec"}
        //             type="button"
        //             className="primary-gradient-btn"
        //           >
        //             Get Started
        //             <span className="icon">
        //               <img alt="" src="/images/si_arrow-right-fill.svg" />
        //             </span>
        //           </Link>
        //         </div>
        //       </div>
        //       <div className="image-contianer">
        //         <img src="/images/main-banner-pic1.png" alt="" />
        //       </div>
        //     </div>
        //   </div>
        //   {/* end: main-banner */}

        //   {/* start: agent-builder-specification-sec */}
        //   <div className="agent-builder-specification-sec">
        //     <div className="custom-container">
        //       <div className="sec-wrapper">
        //         <div className="item-lists">
        //           <div className="item-col">
        //             <div className="item-box">
        //               <div className="icon">
        //                 <img
        //                   src="/images/agent-builder-specification-icon1.svg"
        //                   alt=""
        //                 />
        //               </div>
        //               <div className="text">
        //                 <h3>Build AI Agents Without Coding Expertise</h3>
        //                 <p>
        //                   No coding required, just an easy to use editor that
        //                   simplifies AI creation.
        //                 </p>
        //               </div>
        //             </div>
        //           </div>

        //           <div className="item-col">
        //             <div className="item-box">
        //               <div className="icon">
        //                 <img
        //                   src="/images/agent-builder-specification-icon2.svg"
        //                   alt=""
        //                 />
        //               </div>
        //               <div className="text">
        //                 <h3>Customizable AI to Fit Your Business Needs</h3>
        //                 <p>
        //                   Your business is unique, and so are your needs. The
        //                   GenAI Agent Builder allows you to fully customize AI
        //                   behavior
        //                 </p>
        //               </div>
        //             </div>
        //           </div>

        //           <div className="item-col">
        //             <div className="item-box">
        //               <div className="icon">
        //                 <img
        //                   src="/images/agent-builder-specification-icon3.svg"
        //                   alt=""
        //                 />
        //               </div>
        //               <div className="text">
        //                 <h3>Seamless Integration with Existing Systems</h3>
        //                 <p>
        //                   Our integration capabilities allow your AI agents to
        //                   work within your existing tech ecosystem.
        //                 </p>
        //               </div>
        //             </div>
        //           </div>

        //           <div className="item-col">
        //             <div className="item-box">
        //               <div className="icon">
        //                 <img
        //                   src="/images/agent-builder-specification-icon4.svg"
        //                   alt=""
        //                 />
        //               </div>
        //               <div className="text">
        //                 <h3>Data-Driven Insights to Optimize Performance</h3>
        //                 <p>
        //                   Gain actionable insights with comprehensive analytics
        //                   and reporting tools.{" "}
        //                 </p>
        //               </div>
        //             </div>
        //           </div>
        //         </div>
        //       </div>
        //     </div>
        //   </div>
        //   {/* end: agent-builder-specification-sec */}

        //   {/* start: genAiSolution-Welcome-sec */}
        //   <div
        //     className="genAiSolution-Welcome-sec"
        //     id="genAiSolution-Welcome-sec"
        //   >
        //     <div className="custom-container">
        //       <div className="image-container">
        //         <img src="/images/genAiSolution-Welcome-pic.png" alt="" />
        //       </div>
        //       <div className="text-container">
        //         {/* <div className="tag-area">
        //           <div className="tag-box">GenAI solution</div>
        //         </div> */}
        //         <h1>Welcome to our Agent/Chatbot Builder</h1>

        //         <p>
        //           Using this tool, you can create different types of
        //           Chatbots/Agents for your business website, or your
        //           organization's internal Intranets. Chatbots can be a great way
        //           to engage with your customers anonymously to learn about their
        //           needs and help them get their questions answered without
        //           having to talk with every customer.
        //         </p>
        //         <ul className="icon-with-text-lists">
        //           <li>
        //             <div className="icon">
        //               <img src="/images/icon1.svg" alt="" />
        //             </div>
        //             <div className="text">
        //               <h4>
        //                 If you have an account already, please click on the{" "}
        //                 <span className="link-color">Login </span>
        //                 link to access the tool
        //               </h4>
        //             </div>
        //           </li>
        //           <li>
        //             <div className="icon">
        //               <img src="/images/icon2.svg" alt="" />
        //             </div>
        //             <div className="text">
        //               <h4>
        //                 If you are a customer of{" "}
        //                 <span className="link-color">WIX</span>, we will be
        //                 releasing our solution in the WIX marketplace shortly,
        //                 however you can use our trial here to get started
        //               </h4>
        //             </div>
        //           </li>
        //           <li>
        //             <div className="icon">
        //               <img src="/images/icon3.svg" alt="" />
        //             </div>
        //             <div className="text">
        //               <h4>
        //                 If you want to
        //                 <span className="link-color">
        //                   {" "}
        //                   create Agents for other websites
        //                 </span>{" "}
        //                 (than WIX) or mobile devices, please login to get a
        //                 trial account
        //               </h4>
        //             </div>
        //           </li>
        //         </ul>
        //         <p>
        //           Please note that you will need to log in with a business email
        //           address that matches your website's domain if you wish to
        //           build a Chatbot that answers questions from a scan of your
        //           website (like a Google Search of your website). The log in
        //           screen provides a way to create a new account and password to
        //           achieve this. You cannot use a Gmail account.
        //         </p>
        //         {/* <div>
        //         <SuperAppButton
        //           className='primary-gradient-btn'
        //           size='lg'
        //           onClick={() => {
        //             window.location = "/signin";
        //           }}>
        //           Sign In
        //         </SuperAppButton>
        //       </div> */}
        //       </div>
        //     </div>
        //   </div>
        //   {/* end: genAiSolution-Welcome-sec */}
        // </>
      )}
    </React.Fragment>
  );
}
/*
            <li> If you are a customer of WIX, please click <a href="http://www.wix.com">here</a> to get access through the WIX marketplace</li> 
 <div class="diagonal-text">
    <span>Hi, I'm diagonal</span>
  </div>

                  <div style={{ paddingTop: "50px", textAlign: "center", color: "white" }}>
                  <Link to="/quickstart?id=X&addEmail=true" style={{ textDecoration: 'none' }}>
                  <SuperAppButton>
                      Create your first chatbot in 3 clicks with our Quick Start
                  </SuperAppButton>
                  </Link>
                  </div>
*/
